<form [formGroup]="formGroup" (ngSubmit)="saveConfig()" *ngIf="modConfigModel">
    <div class="form-group">
        <label>Ident: {{ modConfigModel.ident }}</label>
        <div *ngIf="modConfigModel.value_type == 'OPERATOR'">
            <div>
                <app-component-form-search-user
                    [originalValue]="modConfigModel.resolved_value"
                    (userChanged)="updateOperator($event)"
                ></app-component-form-search-user>
            </div>
        </div>
        <div *ngIf="modConfigModel.value_type == 'STRING'">
            <input
                formControlName="value"
                type="text"
                class="form-control form-control-sm"
                placeholder="String"
            />
        </div>
        <div *ngIf="modConfigModel.value_type == 'NUMBER'">
            <input
                formControlName="value"
                type="number"
                class="form-control form-control-sm"
                placeholder="Number"
            />
        </div>
    </div>

    <div class="mt-1">
        <button [disabled]="formGroup.invalid" class="btn btn-sm btn-primary">
            Save
        </button>
        &nbsp;
        <button
            class="btn btn-sm btn-warning"
            (click)="modConfigModel = undefined"
        >
            Cancel
        </button>
    </div>
</form>

<table mat-table #configTable [dataSource]="configs.data" class="table-list">
    <ng-container matColumnDef="control">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let config">
            <div class="btn-group">
                <button
                    [disabled]="!config.mutable"
                    [ngClass]="{
                        'btn btn-sm': true,
                        'btn-success': config.mutable,
                        'btn-secondary': !config.mutable
                    }"
                    (click)="modifyConfig(config)"
                >
                    <i class="bi bi-pencil"></i>
                </button>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let config">
            {{ config.id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="ident">
        <th mat-header-cell *matHeaderCellDef>Ident</th>
        <td mat-cell *matCellDef="let config">
            {{ config.ident }}
        </td>
    </ng-container>

    <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let config">
            {{ config.resolved_value }}
        </td>
    </ng-container>

    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let config">
            {{ config.description }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
</table>
